import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { topicMaster } from '../../Models/TopicMasterModel'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AdminTopicMasterServices {
    apiURL: string = "";
    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
            this.apiURL = sessionStorage.getItem("BaseURL") || '';
            this.apiURL = this.apiURL + 'api/TopicMasterAdmin';
        }
    }

    GetTopicMaster(TokenKey: string, pageIndex: string, pageSize: string, whereCondition: string, orderBy: string): Observable<topicMaster[]> {
        let data = "/" + pageIndex + "/" + pageSize + "/" + whereCondition + "/" + orderBy;
        let fullAPIPath = this.apiURL + '/GetTopicMasterFilterByPage' + data;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.get<topicMaster[]>(fullAPIPath, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetSingleTopicMaster(TokenKey: string, topicId: string): Observable<topicMaster[]> {
        let data = "/" + topicId;
        let fullAPIPath = this.apiURL + '/GetTopicMasterFindByID' + data;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.get<topicMaster[]>(fullAPIPath, httpOptions)
            .pipe(catchError(this.handleError));
    }

    AddUpdateTopicMaster(TokenKey: string, TopicName: string, IsActive: string, TopicId: string, UserID: string): Observable<number> {
        debugger;
        let data = "/" + TopicName + "/" + IsActive + "/" + TopicId + "/" + UserID;
        let fullAPIPath = this.apiURL + '/AddUpdateTopicMaster' + data;

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.post<number>(fullAPIPath, data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    DeleteTopicMaster(TokenKey: string, TopicId: string): Observable<number> {
        let data = "/" + TopicId;
        let fullAPIPath = this.apiURL + '/DeleteTopicMaster' + data;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.get<number>(fullAPIPath, httpOptions)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: Response | any) {
        debugger;
        console.error(error.message || error);
        return Observable.throw(error.status)
    }

}